module.exports = __webpack_public_path__ + "media/images/sad-976c5917fc908c997cab6491e352108a.svg";